import type { ReactNode } from 'react';
import { cx } from '@parrot/utils';
import styles from './ChartSummary.module.css';

export interface ChartSummaryProps {
  children: ReactNode;
  className?: string;
}

/**
 * The narrative sentence that sits above a profile chart — ported from the
 * d360 widgets' `summary` block. Emphasised values use <Emph>, which the two
 * chart organisms compose from live data (never fabricated — render `—` when a
 * value is missing). Semantic tones (purple = retention, teal = acquisition)
 * mirror the d360 colour language.
 */
export function ChartSummary({ children, className }: ChartSummaryProps) {
  return <p className={cx(styles.summary, className)}>{children}</p>;
}

/** Bold emphasis for a figure inside the summary prose. */
export function Emph({ children, tone }: { children: ReactNode; tone?: 'purple' | 'teal' }) {
  return (
    <span className={cx(styles.emph, tone === 'purple' && styles.purple, tone === 'teal' && styles.teal)}>
      {children}
    </span>
  );
}
